import '../../../assets/styles/FullSummary.css';
import { Scan } from '../../../data_layer/models/Scan';
import { inject } from 'mobx-react';
import { FullSummaryPanel } from './FullSummaryPanel';
import { TOTAL_BODY_WATER_INFO, TOTAL_BODY_WATER_PANEL_TITLE } from '../../../assets/ApplicationCopy';
import { Comparision } from '../../pages/Public';
import { NumericRange } from '../Graphs/AreaGraph';

@inject('store')
export class TotalBodyWaterFull extends FullSummaryPanel {

    protected yValueExtractor(scan: Scan): number {
        return (scan.scan_results.totalBodyWaterPounds / scan.scan_results.weightPounds) * 100;
    }

    protected infoText: JSX.Element = TOTAL_BODY_WATER_INFO;
    protected categoryTitle: string = TOTAL_BODY_WATER_PANEL_TITLE;

    protected goodValueComparisionValue = 50;
    protected goodValueComparision = Comparision.LESS_THAN;
    protected showYAxis = true;
    protected yAxisRange: NumericRange = {
        min: 0,
        max: 100.0
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/fullSummaryPanels/TotalBodyWaterFull.tsx